import React from "react";
import SEO from "../components/seo";
import Footer from "../layouts/footer";
import Header from "../layouts/header/index";
import Layout from "../layouts/index";
import Register from "../components/Register";
import ScrollToTop from "../components/scroll-to-top";

const Registration = () => {
    return (
        <React.Fragment>
            <Layout>
                <SEO title="X Chexo FC || Portfolio" />
                <div className="wrapper home-default-wrapper">
                    <Header classOption="hb-border" />
                    <div className="main-content">
                        <Register></Register>
                    </div>
                    <Footer />
                    <ScrollToTop />
                </div>
            </Layout>
        </React.Fragment>
    )
}

export default Registration;